<template>
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-end position-sticky fixed-top">
        <span v-if="isSaving">
          <b-button variant="primary" size="lg" disabled>
            <b-spinner small />
            {{ 'saving' | i18n }}
          </b-button>
        </span>
        <span v-else>
          <b-button variant="primary" size="lg" @click="create">
            {{ 'save' | i18n }}
          </b-button>
        </span>
      </div>
      <div class="poppins planned-content" style="margin-left: -20px">
        <div class="height100 mb-5" v-if="loaded">
          <BlockHeader name="Details" class="ml-1 mt-0" />
          <div class="row ml-0">
            <div class="col-lg-6 col-sm-12 col-xs-12" style="margin-left: 5px">
              <Select v-model="selectedYear" :options="yearOptions" form-group-id="Year" placeholder="year" />
            </div>
          </div>
          <div v-for="key in Object.keys(yearData)" :key="key" class="row" :style="`${bottomOffset[key] ? 'margin-bottom:50px' : ''}`">
            <div class="line-value">
              <div style="width: 400px">
                {{ names[key] | i18n }}
              </div>
              <div style="width: 160px">
                <div>
                  <Input v-model="yearData[key]" :form-group-id="key" type="number" placeholder="" :bottom="0" :disabled="disabled[key]" />
                </div>
              </div>
              <span class="type-value">{{ types[key] }}</span>
            </div>
          </div>
        </div>
        <Loader v-else />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import api from '../../../api';
import Notification from '../../common/notification';

import Input from '../../common/input';
import Select from '../../common/select';
import Loader from '../../common/loader';
import BlockHeader from '../../common/block-header';

const currentYear = Number(moment().format('YYYY'));

export default {
  title: 'Planned Values',
  components: { Input, Loader, BlockHeader, Select },
  data() {
    return {
      loaded: true,
      isSaving: false,
      selectedYear: currentYear,
      yearOptions: [],
      disabled: {
        Kalendertage: true,
        Anliefertage: true,
      },
      bottomOffset: {
        Dispersionsfarben: true,
        Anliefertage: true,
        Stromlieferung: true,
        Abschaltumlage: true,
        'Bunkerstand zu Beginn der Statistik': true,
      },
      types: {
        'Stadt Köln, Hausmüll': 't',
        'Stadt Köln, Sperrmüll': 't',
        'Stadt Köln, Sperrmüllrückführung': 't',
        'REMONDIS RHEINLAND': 't',
        'AVG-R': 't',
        'Schlamm Deponie': 't',
        'Konzentrat Deponie': 't',
        Dispersionsfarben: 't',
        Verbrennungsmenge: 't',
        Kalendertage: '',
        Anliefertage: '',
        'Fe-Ausschleusung VSA': 't',
        Rostasche: 't',
        Reststoffe: 't',
        Gips: 't',
        Kalk: 't',
        Ammoniakwasser: 't',
        Herdofenkoks: 't',
        'Stickstoff N2': 't',
        Erdgas: 'm³',
        Heizöl: 'l',
        Strombezug: 'MWh',
        Wärmelieferung: 'MWh',
        Stromlieferung: 'MWh',
        'Entsorgungskosten Rostasche': '€/t',
        'Entsorgungskosten Filterstäube': '€/t',
        'Entsorgungskosten Gips': '€/t',
        'Entsorgungskosten Strahlsand': '€/t',
        'Beschaffungskosten Kalk': '€/t',
        'Beschaffungskosten Ammoniakwasser': '€/t',
        'Beschaffungskosten Herdofenkoks': '€/t',
        'Beschaffungskosten Stickstoff': '€/t',
        'Fixkosten externe Instandhaltung': '€/a',
        'Variabler Anteil externe Instandhaltung': '€/t',
        'Nachtrag 2 Energieteil und Prüfungen': '€/a',
        'Vergütungsanpassung wg Wertentwicklung': '€/a',
        Industriereinigung: '€/a',
        'Kosten Sperrmüllaufbereitung': '€/t',
        'Erlös Stromlieferung': '€/MWh',
        'Kosten Strombezug': '€/MWh',
        'Abschlag Netznutzung': '€/a',
        'Abschlag Vermiedene Netznutzung': '€/a',
        'EEG-Umlage': '€/MWh',
        'KWK-Umlage': '€/MWh',
        '19 StromNEV Erste 1000 MWh': '€/MWh',
        '19 StromNEV Über 1000 MWh': '€/MWh',
        'Offshore-Umlage': '€/MWh',
        Abschaltumlage: '€/MWh',
        'Bunkerstand zu Beginn der Statistik': 't',
        'Umrechnung Ferndampf in Wärmeenergie': 'MWh/t',
      },
      names: {
        'Stadt Köln, Hausmüll': 'City of Cologne, household waste',
        'Stadt Köln, Sperrmüll': 'City of Cologne, bulky waste (to AVG-R)',
        'Stadt Köln, Sperrmüllrückführung': 'City of Cologne, bulky waste recovery',
        'REMONDIS RHEINLAND': 'Remondis Rhineland',
        'AVG-R': 'AVG-R',
        'Schlamm Deponie': 'Sludge landfill',
        'Konzentrat Deponie': 'Concentrate landfill',
        Dispersionsfarben: 'Dispersion colors',
        Verbrennungsmenge: 'Incineration',
        Kalendertage: 'Calendar days',
        Anliefertage: 'Delivery days',
        'Fe-Ausschleusung VSA': 'Fe emissions VSA',
        Rostasche: 'Rosebag',
        Reststoffe: 'Residues',
        Gips: 'Plaster',
        Kalk: 'Lime',
        Ammoniakwasser: 'Ammonia water',
        Herdofenkoks: 'Stove coke',
        'Stickstoff N2': 'Nitrogen',
        Erdgas: 'Natural gas',
        Heizöl: 'Fuel oil',
        Strombezug: 'Electricity Purchase',
        Wärmelieferung: 'Heat delivery (as electrical energy)',
        Stromlieferung: 'Electricity delivery',
        'Entsorgungskosten Rostasche': 'Disposal costs rose pocket',
        'Entsorgungskosten Filterstäube': 'Disposal costs filter dust',
        'Entsorgungskosten Gips': 'Disposal costs Gips',
        'Entsorgungskosten Strahlsand': 'Disposal costs beam sand',
        'Beschaffungskosten Kalk': 'Procurement costs lime',
        'Beschaffungskosten Ammoniakwasser': 'Procurement costs ammonia water',
        'Beschaffungskosten Herdofenkoks': 'Procurement costs stove koks',
        'Beschaffungskosten Stickstoff': 'Procurement costs nitrogen',
        'Fixkosten externe Instandhaltung': 'Fixed costs external maintenance',
        'Variabler Anteil externe Instandhaltung': 'Variable proportion of external maintenance',
        'Nachtrag 2 Energieteil und Prüfungen': 'Addendum 2nd energy part and exams',
        'Vergütungsanpassung wg Wertentwicklung': 'Remuneration adjustment due to Performance',
        Industriereinigung: 'Industrial cleaning',
        'Kosten Sperrmüllaufbereitung': 'Cost bulky waste processing',
        'Erlös Stromlieferung': 'Revenue electricity delivery',
        'Kosten Strombezug': 'Cost electricity reference',
        'Abschlag Netznutzung': 'Discount network use',
        'Abschlag Vermiedene Netznutzung': 'Discount avoided network use',
        'EEG-Umlage': 'EEG surcharge',
        'KWK-Umlage': 'KWK surcharge',
        '19 StromNEV Erste 1000 MWh': '§19 Stromnev (first 1,000 MWh)',
        '19 StromNEV Über 1000 MWh': '§19 Stromnev (over 1,000 MWh)',
        'Offshore-Umlage': 'Offshore surcharge',
        Abschaltumlage: 'Shutdown',
        'Bunkerstand zu Beginn der Statistik': 'Bunker stand at the beginning of the statistics',
        'Umrechnung Ferndampf in Wärmeenergie': 'Conversion remote vapor into thermal energy',
      },
      yearData: {
        'Stadt Köln, Hausmüll': '',
        'Stadt Köln, Sperrmüll': '',
        'Stadt Köln, Sperrmüllrückführung': '',
        'REMONDIS RHEINLAND': '',
        'AVG-R': '',
        'Schlamm Deponie': '',
        'Konzentrat Deponie': '',
        Dispersionsfarben: '',
        Verbrennungsmenge: '',
        Kalendertage: '',
        Anliefertage: '',
        'Fe-Ausschleusung VSA': '',
        Rostasche: '',
        Reststoffe: '',
        Gips: '',
        Kalk: '',
        Ammoniakwasser: '',
        Herdofenkoks: '',
        'Stickstoff N2': '',
        Erdgas: '',
        Heizöl: '',
        Strombezug: '',
        Wärmelieferung: '',
        Stromlieferung: '',
        'Entsorgungskosten Rostasche': '',
        'Entsorgungskosten Filterstäube': '',
        'Entsorgungskosten Gips': '',
        'Entsorgungskosten Strahlsand': '',
        'Beschaffungskosten Kalk': '',
        'Beschaffungskosten Ammoniakwasser': '',
        'Beschaffungskosten Herdofenkoks': '',
        'Beschaffungskosten Stickstoff': '',
        'Fixkosten externe Instandhaltung': '',
        'Variabler Anteil externe Instandhaltung': '',
        'Nachtrag 2 Energieteil und Prüfungen': '',
        'Vergütungsanpassung wg Wertentwicklung': '',
        Industriereinigung: '',
        'Kosten Sperrmüllaufbereitung': '',
        'Erlös Stromlieferung': '',
        'Kosten Strombezug': '',
        'Abschlag Netznutzung': '',
        'Abschlag Vermiedene Netznutzung': '',
        'EEG-Umlage': '',
        'KWK-Umlage': '',
        '19 StromNEV Erste 1000 MWh': '',
        '19 StromNEV Über 1000 MWh': '',
        'Offshore-Umlage': '',
        Abschaltumlage: '',
        'Bunkerstand zu Beginn der Statistik': '',
        'Umrechnung Ferndampf in Wärmeenergie': '',
      },
      allInfo: {},
    };
  },
  watch: {
    selectedYear(newVal) {
      localStorage.setItem('selectedYear', newVal);
      if (this.allInfo[newVal]) {
        Object.keys(this.yearData).forEach((key) => {
          this.yearData[key] = this.allInfo[newVal][key];
        });
      } else {
        Object.keys(this.yearData).forEach((key) => {
          this.yearData[key] = '';
        });
      }
    },
  },
  async created() {
    const yearList = await api.year.get();
    this.yearOptions = yearList.data.map(({ year }) => year);
    this.selectedYear = localStorage.getItem('selectedYear') || currentYear;
    this.init();
  },
  methods: {
    async init() {
      const responce = await api.plannedValues.get();
      responce.forEach((item) => {
        this.allInfo[item.year] = item;
      });
      if (this.allInfo[this.selectedYear]) {
        Object.keys(this.yearData).forEach((key) => {
          this.yearData[key] = this.allInfo[this.selectedYear][key];
        });
      }
    },
    async create() {
      try {
        this.isSaving = true;
        await api.plannedValues.create({
          ...this.yearData,
          year: this.selectedYear,
        });
        Notification({ type: 'success', title: this.$translate('success'), message: this.$translate('success') });
        this.init();
      } catch (err) {
        Notification({ type: 'error', message: err.message });
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.planned-content {
  overflow-x: hidden;
}

.line-value {
  display: flex;
  margin-left: 35px;
  align-items: center;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  margin-top: 20px;
  padding: 10px;
}

.type-value {
  margin-left: 10px;
  width: 90px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
